<template>
  <v-alert
    class="text-body-1 d-flex justify-center"
    dense
    type="error"
  >
    Le service est momentanément indisponible. Veuillez rééssayer ultérieurement.
  </v-alert>
</template>

<script>
export default {
  name: 'BaseMessageServerError'
}
</script>
<style scoped>
.v-alert:not(.v-sheet--tile) {
  border-radius: 35px;
}

.v-alert >>> i {
  margin: auto;
  padding-right: 8px;
}
</style>
